import React, {useState} from "react";
import themeImage from "../../../assets/images/Light-Canvas.jpg"
import ThemeVariationPopup from "./themePopup";
const ThemeList = () => {
    //function to show popup
    const [openPopup, setPopup] = useState(false);
    const handlePopup = () => {
        setPopup(true);
    }
     
    return (
        <div className="theme-area">
            <div className="theme-wrapper">
                <div className="single-theme">
                    <img src={themeImage}  alt="theme image" />
                    <div className="theme-footer">
                        <button class="btn theme-active">Active</button>
                        <button class="btn theme-variation" onClick={handlePopup}>Variation</button>
                    </div>
                </div>
                <div className="single-theme">
                    <img src={themeImage}  alt="theme image" />
                    <div className="theme-footer">
                        <button class="btn theme-active">Active</button>
                        <button class="btn theme-variation" onClick={handlePopup}>Variation</button>
                    </div>
                </div>
                <div className="single-theme">
                    <img src={themeImage}  alt="theme image" />
                    <div className="theme-footer">
                        <button class="btn theme-active">Active</button>
                        <button class="btn theme-variation" onClick={handlePopup}>Variation</button>
                    </div>
                </div>
                <div className="single-theme">
                    <img src={themeImage}  alt="theme image" />
                    <div className="theme-footer">
                        <button class="btn theme-active">Active</button>
                        <button class="btn theme-variation" onClick={handlePopup}>Variation</button>
                    </div>
                </div>
                <div className="single-theme">
                    <img src={themeImage}  alt="theme image" />
                    <div className="theme-footer">
                        <button class="btn theme-active">Active</button>
                        <button class="btn theme-variation" onClick={handlePopup}>Variation</button>
                    </div>
                </div>
            </div>
            <ThemeVariationPopup openModal={openPopup} setOpen={setPopup} />
        </div>
    )
}
export default ThemeList;